import { render } from "./BulkWhitelist.vue?vue&type=template&id=e272b5c2"
import script from "./BulkWhitelist.vue?vue&type=script&lang=js"
export * from "./BulkWhitelist.vue?vue&type=script&lang=js"

import "./BulkWhitelist.vue?vue&type=style&index=0&id=e272b5c2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__